import { RmaAdditionalDetails, SalseOrgDetails, StandardReturnOrderDetails } from "@dana/Services/StandardReturnDetailsService";
import StandardReturnsDetailsState from "@dana/Store/Data/StandardReturnsStatus/StandardReturnsDetailsState";
import { SystemListValuesModel } from "@dana/Types/ApiModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: StandardReturnsDetailsState = {
    isLoading: false,
    orderModel: undefined,
    logo: "",
    salseOrgDetails: undefined,
    rmaAdditionalDetails: undefined,
    dispositionPreferences: undefined
};

const StandardReturnsDetailsStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "StandardReturnsOrerDetails/Init": (draft: Draft<StandardReturnsDetailsState>, action: { isLoading: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading };
        return draft;
    },
    "StandardReturnsOrerDetails/IsLoading": (draft: Draft<StandardReturnsDetailsState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },
    "StandardReturnsOrerDetails/LoadData": (draft: Draft<StandardReturnsDetailsState>, action: { orderModel: StandardReturnOrderDetails, salseOrgDetails: SalseOrgDetails, rmaAdditionalDetails: RmaAdditionalDetails,logo:string ,dispositionPreferences:SystemListValuesModel[]}) => {
        draft = {
            ...draft,
            logo:action.logo,
            orderModel: action.orderModel,
            rmaAdditionalDetails: action.rmaAdditionalDetails,
            salseOrgDetails: action.salseOrgDetails,
            dispositionPreferences : action.dispositionPreferences
        };
        return draft;
    },
});

(reducers as any).standardReturnsDetailsState = StandardReturnsDetailsStateImmerReducer;

type CreditStateReducers = {
    standardReturnsDetailsState: typeof StandardReturnsDetailsStateImmerReducer;
};

export type StandardReturnsDetailsStateActions = Parameters<CreditStateReducers[keyof CreditStateReducers]>[1] | AnyAction;

